/* eslint-disable @typescript-eslint/dot-notation */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import cdnAssets from 'cdn-assets';

if (environment.production) {
  enableProdMode();
}

const loadExternalScript = (src: string, onLoad: (err?: Error) => void) => {
  const script = document.createElement('script');
  script.src = src;
  script.defer = true;
  script.onload = () => onLoad();
  script.onerror = () => onLoad(new Error(`Failed to load ${src}`));
  document.head.appendChild(script);
};

Promise.allSettled(
  cdnAssets.map(
    (url) =>
      new Promise<void>((resolve, reject) => {
        loadExternalScript(url, (err) => (err ? reject(err) : resolve()));
      })
  )
).then((results) => {
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.error(`Failed to load script: ${cdnAssets[index]}`, result.reason);
    }
  });

  const zonePromise = !window['Zone']
    ? import('zone.js/dist/zone')
    : Promise.resolve();

  zonePromise
    .then(() => {
      platformBrowserDynamic()
        .bootstrapModule(AppModule, { preserveWhitespaces: true })
        .catch((err) => console.error('Bootstrap error:', err));
    })
    .catch((err) => {
      console.error('Zone.js load failure:', err);

      platformBrowserDynamic()
        .bootstrapModule(AppModule, { preserveWhitespaces: true })
        .catch((e) => console.error('Bootstrap error without Zone.js:', e));
    });
});

// TODO: Set the environment through airConfig slice in the ngrx/store
// Set the environment variable for AIR. Short term solution
window['airEnv'] = environment.envName;
window['_wrs_conf_setSize'] = true;
window['_wrs_conf_wirisPluginPerformance'] = false;
window['_wrs_conf_wirisEditorSaveMode'] = 'image';
window['_wrs_conf_imageClassName'] = 'Wirisformula';
window['_wrs_conf_saveMode'] = 'xml';
window[
  '_wrs_int_conf_file'
] = `${environment.wirisUrl}/api/integration/configurationjs.php`;
